const validCurrencies = new Set([
  'EUR',
  'ALL',
  'BAM',
  'BGN',
  'CHF',
  'CZK',
  'DKK',
  'GBP',
  'HUF',
  'ISK',
  'MDL',
  'MKD',
  'NOK',
  'PLN',
  'RON',
  'RSD',
  'RUB',
  'SEK',
  'TRY',
  'UAH',
]);

export default (
  number: number,
  locale: string = 'de-DE',
  options: { currency: string; minimumFractionDigits: number; maximumFractionDigits: number } = {
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }
) => {
  if (!validCurrencies.has(options.currency)) {
    options.currency = 'EUR';
  }

  return number.toLocaleString(locale, { style: 'currency', ...options });
};
